import React from 'react';
import { TextLarge, TextRegular, TextSmall } from '@hz-design-system/web-ui';

import Classes from './ListingLocationDetails.module.scss';

interface Location {
  label: string;
  distance?: string;
}

interface ListingLocationDetailsProps {
  location: Location;
}

interface ListingLocationDetailsComponent {
  Large: React.FC<ListingLocationDetailsProps>;
  Regular: React.FC<ListingLocationDetailsProps>;
  Small: React.FC<ListingLocationDetailsProps>;
}

const ListingLocationDetailsLarge: React.FC<ListingLocationDetailsProps> = ({ location }) => {
  return (
    <>
      {location.label && (
        <TextLarge color="text-secondary" className={Classes['hz-Listing-location-label']} data-testid="location-label">
          {location.label}
        </TextLarge>
      )}
      {location.distance && (
        <TextLarge
          color="text-secondary"
          className={Classes['hz-Listing-location-distance']}
          data-testid="location-distance"
        >
          {location.distance}
        </TextLarge>
      )}
    </>
  );
};

const ListingLocationDetailsRegular: React.FC<ListingLocationDetailsProps> = ({ location }) => {
  return (
    <>
      {location.label && (
        <TextRegular
          color="text-secondary"
          className={Classes['hz-Listing-location-label']}
          data-testid="location-label"
        >
          {location.label}
        </TextRegular>
      )}
      {location.distance && (
        <TextRegular
          color="text-secondary"
          className={Classes['hz-Listing-location-distance']}
          data-testid="location-distance"
        >
          {location.distance}
        </TextRegular>
      )}
    </>
  );
};

const ListingLocationDetailsSmall: React.FC<ListingLocationDetailsProps> = ({ location }) => {
  return (
    <>
      {location.label && (
        <TextSmall color="text-secondary" className={Classes['hz-Listing-location-label']} data-testid="location-label">
          {location.label}
        </TextSmall>
      )}
      {location.distance && (
        <TextSmall
          color="text-secondary"
          className={Classes['hz-Listing-location-distance']}
          data-testid="location-distance"
        >
          {location.distance}
        </TextSmall>
      )}
    </>
  );
};

const ListingLocationDetails: ListingLocationDetailsComponent = {
  Large: ListingLocationDetailsLarge,
  Regular: ListingLocationDetailsRegular,
  Small: ListingLocationDetailsSmall,
};

export default ListingLocationDetails;
